import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-spinner',
  templateUrl: './auth-spinner.component.html',
  styleUrls: ['./auth-spinner.component.scss']
})
export class AuthSpinnerComponent implements OnInit {

  @Input() message = '';

  constructor() { }

  ngOnInit(): void {
  }

}
